import { PaginatedProducts } from "../types/Product";
import { httpClient } from "./client";
import { ProductCategoryFilter } from "../types/Category";

export const HttpCategoryProduct = {
    getEndpoint: (url: string): string => `/categoria/productos/${url}`,

    getProductsByCategoryId: (
        categoryGuid: string,
        page: number = 1,
        pageSize: number = 20,
    ): Promise<PaginatedProducts> => {
        return httpClient.getWithQueryParamsSerializer<PaginatedProducts>(
            HttpCategoryProduct.getEndpoint(`${categoryGuid}`),
            { pagina: page, tamanoPagina: pageSize },
        );
    },

    getProductsByCategorySku: (
        categoriaSku: string,
        filter?: ProductCategoryFilter,
    ): Promise<PaginatedProducts> => {
        return httpClient.getWithQueryParamsSerializer<PaginatedProducts>(
            HttpCategoryProduct.getEndpoint(`sku/${categoriaSku}`),
            filter,
        );
    },
};
